"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ContentInner = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _dynamicModifiers = require("../../utils/dynamicModifiers");

var _styleModifiers = require("../../utils/styleModifiers");

var _skyPlane = _interopRequireDefault(require("../../utils/skyPlane"));

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var oppositeSideOf = {
  top: 'bottom',
  right: 'left',
  bottom: 'top',
  left: 'right'
};

var getContentPadding = function getContentPadding(_ref) {
  var placement = _ref.placement,
      hasArrow = _ref.hasArrow;

  if (!hasArrow) {
    return '';
  }

  var _getPlacementParts = (0, _utils.getPlacementParts)(placement),
      _getPlacementParts2 = _slicedToArray(_getPlacementParts, 1),
      side = _getPlacementParts2[0];

  var prop = "padding-".concat(oppositeSideOf[side]);
  return _defineProperty({}, prop, _constants.arrowSize.height);
};

var bgColor = (0, _toColorString.default)(_color.default.base.snowWhite);

var ContentInner = _styledComponents.default.div.withConfig({
  displayName: "Content__ContentInner",
  componentId: "sc-1yww2zb-0"
})(["background:", ";border-radius:2px;box-shadow:", ";", ";", ";"], bgColor, (0, _skyPlane.default)(), (0, _styleModifiers.when)('aria-hidden', (0, _styledComponents.css)(["display:none;"])), (0, _dynamicModifiers.applyDynamicModifiers)('borderRadius', 'border-radius'));

exports.ContentInner = ContentInner;

var getZIndex = function getZIndex(_ref3) {
  var zIndex = _ref3.zIndex;
  return (0, _styledComponents.css)(["z-index:", ";"], zIndex !== undefined ? zIndex : 'auto');
};

var PopoverContent = _styledComponents.default.div.withConfig({
  displayName: "Content__PopoverContent",
  componentId: "sc-1yww2zb-1"
})(["", ";", ";"], getContentPadding, getZIndex);

var _default = PopoverContent;
exports.default = _default;